// src/redux/OurServices/services.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../lib/api";

export const fetchServices = createAsyncThunk("services/fetch", async (_, { signal, rejectWithValue }) => {
  try { const r = await api.get("our_services", { signal }); return r.data.data; }
  catch (e) { return rejectWithValue(e?.response?.data || e.message); }
});

const slice = createSlice({
  name: "services",
  initialState: { servicesData: null, categoryDataServ: null, categoryDataShop: null, categpryDataAll: null, status: "idle", error: null },
  reducers: {
    setCategServers: (state, actions) => { state.categoryDataServ = actions.payload; },
    setCategShop: (state, actions) => { state.categoryDataShop = actions.payload; },
    setCateDataAll: (state, actions) => { state.categpryDataAll = actions.payload; }
  },
  extraReducers: (b) => {
    b.addCase(fetchServices.pending, (s) => { s.status = "loading"; s.error = null; })
     .addCase(fetchServices.fulfilled, (s, a) => { s.status = "succeeded"; s.servicesData = a.payload; })
     .addCase(fetchServices.rejected, (s, a) => { s.status = "failed"; s.error = a.payload || a.error.message; });
  }
});

export const { setCategServers, setCategShop, setCateDataAll } = slice.actions;
export const servicesState = (state) => state.services;
export default slice.reducer;
